// extracted by mini-css-extract-plugin
export default {"box":"refundFilterPage_box__osd+L","box__content":"refundFilterPage_box__content__6KtgA"};